import React, { useContext, useEffect, useRef, useState } from 'react';

import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png"
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';

import { useNavigate } from 'react-router-dom';
import { goBack, isEmpty, setStorage, getStorage } from '../../../Utils/common';
import PictureUpload from '../../../components/PictureUpload/PictureUpload';
import { ButtonWrapper } from '../../../components/ui/style';
import { uploadProfilePhoto, getDashboardData } from '../../../Utils/api';
import ContextDashboard from '../../../Context/ContextDashboard';
import photoCapturIcon from "../../../images/photo-capture.svg";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import { ArrowLeft } from 'lucide-react';



function UploadBankStatement() {
  const [loading, setLoading] = useState(false);
  const [responce, setResponce] = useState({});
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [image, setImage] = useState("");
  const [base64, setBase64] = useState("");
  const [showSteps, setShowSteps] = useState(-1);
  const [toggle, setToggle] = useState(true);
  const [progressBar, setProgressBar] = useState(0);

  const { logout, profileData, getProfileDaital, setps } = useContext(ContextDashboard);

  useEffect(() => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      const data = base64.split(",");
      let img = data[data.length - 1];
      setBase64(img)

    };

    if (image) {
      if (typeof image === "string") {
        const blob = new Blob([image]);
        reader.readAsDataURL(blob);
      } else {
        reader.readAsDataURL(image);
      }
    }
  }, [image]);
  const submit = () => {

    if (image === "" && base64 === "") {
      setMessage({
        type: "error",
        msg: "Please select  pan image",
        place: "local",
      });
      return;
    } else {
      setMessage({});
    }

    let ext = "PDF";
    if (typeof image === "object") {
      let extArr = image.name.split(".");
      ext = extArr[extArr.length - 1].toUpperCase();
    }
    const param = {
      lead_id: getStorage("lead_id") || "",
      token: getStorage("token") || "",
      file: base64,
      ext: ext,
      password: "N/A",
      docs_id: "6",
    };
    setLoading(true);
    uploadProfilePhoto(param).then((resp) => {
      setLoading(false);
      console.log(resp?.data);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });
        getProfileDaital();
        navigate("/my-dashboard/upload-salaryslip");
      } else if (resp?.data?.Status === 5) {
        logout();
      } else {
        setMessage({ type: "error", msg: resp?.data?.Message });
      }
    });


  };

  useEffect(() => {

    const params = {
      lead_id: getStorage("lead_id") || "",
      token: getStorage("token") || "",
      mobile: getStorage("mobile") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data?.Steps?.data || {};
        if (dashboardData) {

          setProgressBar(resp?.data?.Steps?.steps?.step_complete_percent);
        }
      } else if (resp?.data?.Status === 5) {
        logout();
      }
    });
  }, [logout]);


  return (
    <><ProgressBar value={`${progressBar}%`}>

      <div >

      </div>
      <></>
    </ProgressBar>
      <br />




      <BoxWrapper className="w-full min-h-screen p-3 sm:p-5 md:p-8">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6">

          {/* Back Button */}
          <div
            onClick={() => goBack(navigate, "/my-dashboard/pan-upload")}
            className="flex w-fit cursor-pointer items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-3 transition hover:bg-gray-50 mb-4"
          >
            <ArrowLeft className="h-5  w-5 text-[#1D3557]" />
            <span className="font-medium text-[#1D3557]">Back</span>
          </div>

          {/* Title */}


        </div>

        <div className="w-full max-w-5xl mx-auto rounded-3xl bg-white shadow-lg border border-gray-100 p-5 sm:p-7 lg:p-10">

          {/* Header */}
          <div className="flex-1">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1D3557] leading-tight">
              Upload Your Bank Statement
              <span className="ml-1 text-red-500">*</span>
            </h2>

            <p className="mt-2 text-sm sm:text-base text-gray-500">
              Upload your last 6 months bank statement for verification.
            </p>
          </div>

          {/* Form */}
          <FormWrapper className="mt-8">

            <Alert
              setMessage={setMessage}
              message={message}
            />

            {/* Upload Section */}
            <div className="mb-6">
              <h3 className="mb-4 text-lg sm:text-xl font-semibold text-[#1D3557]">
                Bank Statement
              </h3>

              <PictureUpload
                setImage={setImage}
                image={image}
                accept="application/pdf"
                type="file"
              />
            </div>

            {/* Security Card */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4 rounded-2xl border border-green-200 bg-green-50 p-5">

              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-white shadow">
                <span className="text-2xl">🔒</span>
              </div>

              <div>
                <h4 className="text-base sm:text-lg font-semibold text-[#1D3557]">
                  Your information is safe with us
                </h4>

                <p className="mt-2 text-sm sm:text-base text-gray-600 leading-6">
                  Your bank statement is securely encrypted and used only for
                  verification purposes. We never share your personal information.
                </p>
              </div>

            </div>

            {/* Continue Button */}
            <div className="mt-8">
              <Button
                className="w-full bg-[#2D5F7A]"
                title="Continue"
                onClick={submit}
                loading={loading}
              />
            </div>


          </FormWrapper>

        </div>
      </BoxWrapper>
    </>
  )
}

export default UploadBankStatement;